import { ReactNode } from 'react';
import { useAccessibleCourses } from 'edrolo/domains/coursePortal/hooks';
import { CourseFeature } from 'edrolo/domains/coursePortal/types/Courses';

interface FeatureGateProps {
  feature: CourseFeature;
  courseId?: number;
  children: ReactNode;
  fallback?: ReactNode;
}

// Gates its children on the user having access to a feature, using the feature-based
// accessible-courses endpoint (access via school subscription or class membership).
// Optional courseId argument used to gate children based on whether a specific course
// has access to a feature.
export const FeatureGate = ({
  feature,
  courseId,
  children,
  fallback = null,
}: FeatureGateProps) => {
  const { data: courses, loading, error } = useAccessibleCourses([feature]);

  // Avoid a flash of gated content.
  if (loading) {
    return null;
  }

  if (error) {
    return <>{fallback}</>;
  }

  const hasAccess =
    courseId !== undefined
      ? courses.some((course) => course.id === courseId)
      : courses.length > 0;

  return hasAccess ? <>{children}</> : <>{fallback}</>;
};
